import { StyledButton } from "../../utils/theme";
import SendIcon from '@mui/icons-material/Send';

interface ConfirmButtonProps {
  onClick: () => void;
}

const ConfirmButton = ({ onClick }: ConfirmButtonProps) => {
  return (
    <StyledButton onClick={onClick}>
      送信
      <SendIcon />
    </StyledButton>
  );
};

export default ConfirmButton;
